import { storage } from '@otto-ec/global-resources/storage';
import { log } from '@shared/log.browser.ts';

export type CacheStorage = Pick<Storage, 'getItem' | 'removeItem' | 'setItem'>;

const getCacheStorage = (): CacheStorage => storage(window.sessionStorage);

const ID_KEY = 'reptile_dundee_cacheId';

export const CACHE_DURATION_MINUTES = 5;

export async function refreshCacheKey(
    minutes?: number,
    id = ID_KEY,
    href = window.location.href,
    cacheStorage = getCacheStorage(),
) {
    const hash = generateHash(href.replace(new URL(href).hash, ''));
    await safeSetItem(id, (minutes ?? getMinutes()) + '_' + hash, cacheStorage);
}

export async function deleteContent(contentKey: string, cacheStorage = getCacheStorage()) {
    if ((await safeGetItem(contentKey, cacheStorage)) != null) {
        cacheStorage.removeItem(contentKey);
    }
}

export async function cacheIsValid(id = ID_KEY, href = window.location.href, cacheStorage = getCacheStorage()) {
    const keys = await safeGetItem(id, cacheStorage);
    let result;

    if (keys != null) {
        result = keys.split('_');
        const durationCheck = getMinutes() - parseInt(result[0], 10) <= CACHE_DURATION_MINUTES;
        const htmlHashCheck = parseInt(result[1], 10) === generateHash(href.replace(new URL(href).hash, ''));
        return durationCheck && htmlHashCheck;
    }

    return false;
}

export async function safeSetItem(key: string, val: string, cacheStorage = getCacheStorage()) {
    try {
        cacheStorage.setItem(key, val);
    } catch (err) {
        log.error(err);
    }
}

export async function safeGetItem(key: string, cacheStorage = getCacheStorage()) {
    try {
        return cacheStorage.getItem(key);
    } catch (err) {
        log.debug(err);
    }
}

export function generateHash(value: string): number {
    let hash = 0;
    let i;
    let chr;
    let len;

    if (value.length === 0) {
        return hash;
    }

    for (i = 0, len = value.length; i < len; i++) {
        chr = value.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; /*                       */
    }

    return hash;
}

function getMinutes() {
    return Math.floor(Date.now() / 1000 / 60);
}
